module.exports = __webpack_public_path__ + "static/img/53e16e1f8ea1da4fe2f514786f1619c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/首页-改-2_30.png
// module id = IbY7
// module chunks = 1